// @ts-nocheck
import * as actions from '../../action-types';
import * as mutations from '../../mutation-types';
import axios from 'axios';
import config from '@/config';
import logger from '@/app/logger';

const prune = (data) => {
  Object.keys(data).forEach((key) => {
    if (!data[key]) {
      delete data[key];
    }
  });
  return data;
};

export default {
  [actions.POST_BASIC_CONTACT_FORM]: ({ commit, dispatch }, data) => {
    // Remove empties from the payload

    data = prune(data);
    logger.debug('inside action?', { data });
    return axios
      .post('/api/contact', data)
      .then((result) => {
        logger.debug('was sent?', { result });
        dispatch(actions.analytics.track, config.analytics.eventTypes.form.completed);
        commit(mutations.SET_FORM_RESULT, result.status);
      })
      .catch((error) => {
        logger.error('no send', error);
        dispatch(actions.analytics.set, {
          eVar14: `Form failed with status ${error.response.status}`,
        });
        dispatch(actions.analytics.track, config.analytics.eventTypes.form.error);
        commit(mutations.SET_FORM_ERROR, error.response.status);
      });
  },
  [actions.RESET_CONTACT_FORM_RESULTS]: ({ commit }) => {
    commit(mutations.SET_FORM_RESULT, 0);
    commit(mutations.SET_FORM_ERROR, 0);
  },
  [actions.POST_CALCULATOR_FEEDBACK_CONTACT]: ({ commit, dispatch }, data) => {
    // Remove empties from the payload
    data = prune(data);
    commit(mutations.SET_LOADING, true);
    axios
      .post('/api/email/feedback', data)
      .then(() => {
        dispatch(actions.analytics.track, config.analytics.eventTypes.form.completed);
        commit(mutations.SET_FEEDBACK_FORM_RESULT);
        commit(mutations.SET_LOADING, false);
      })
      .catch((error) => {
        dispatch(actions.analytics.set, {
          eVar14: `Calculator feedback contact failed with status ${error.response.status}`,
        });
        dispatch(actions.analytics.track, config.analytics.eventTypes.form.error);
        commit(mutations.SET_FEEDBACK_FORM_ERROR, error.response.status);
        commit(mutations.SET_LOADING, false);
      });
  },

  [actions.POST_RENTAL_APPLICATION]: ({ commit }, data) => {
    // Remove empties from the payload
    data = prune(data);
    return axios
      .post('/api/rentalApplication', data)
      .then((result) => {
        if (result.data.success) {
          commit(mutations.SET_FORM_RESULT, result.status);
        } else {
          commit(mutations.SET_RENT_FORM_ERROR, result.data.message);
        }
      })
      .catch((error) => {
        commit(mutations.SET_FORM_ERROR, error.response.status);
      });
  },

  [actions.SET_RENT_FORM_ERROR]: ({ commit }, data) => {
    commit(mutations.SET_RENT_FORM_ERROR, data);
  },
};
